/* Product layout fix: fallback for cached product section HTML. */
(() => {
  const run = () => {
    document.querySelectorAll('.product-page').forEach((page) => {
      const details = page.querySelector('.product-page__details');
      if (!details) return;
      page.classList.add('product-page--purchase-first');

      const form = details.querySelector('[data-product-form], .product-form');
      const description = details.querySelector('.product-page__description');
      if (form) form.classList.add('product-form--priority');

      if (form && description && !description.closest('.product-description-accordion')) {
        details.insertBefore(form, description);
        const accordion = document.createElement('details');
        accordion.className = 'product-description-accordion';
        const summary = document.createElement('summary');
        summary.textContent = 'Product details';
        description.parentNode.insertBefore(accordion, description);
        accordion.appendChild(summary);
        accordion.appendChild(description);
      }

      page.querySelectorAll('.payment-options,.product-form__direct-buy').forEach((item) => { item.hidden = true; item.style.display = 'none'; });
      if (!form) return;

      const addButton = form.querySelector('[data-add-to-bag]');
      const variantSelect = form.querySelector('[name="id"]');
      const quantityInput = form.querySelector('[name="quantity"]');
      let actions = addButton?.closest('.product-form__checkout-actions') || form.querySelector('.product-form__checkout-actions');
      if (!actions && addButton) {
        actions = document.createElement('div');
        actions.className = 'product-form__checkout-actions';
        addButton.parentNode.insertBefore(actions, addButton);
        actions.appendChild(addButton);
      }
      if (!actions) return;

      let buyLink = form.querySelector('[data-buy-now]');
      if (!buyLink || buyLink.tagName !== 'A') {
        const replacement = document.createElement('a');
        replacement.className = buyLink?.className || 'product-form__checkout-now';
        replacement.dataset.buyNow = '';
        replacement.dataset.directCheckout = '';
        replacement.setAttribute('role', 'button');
        replacement.textContent = 'Buy it now';
        if (buyLink) buyLink.replaceWith(replacement); else actions.appendChild(replacement);
        buyLink = replacement;
      }
      buyLink.classList.add('product-form__checkout-now');

      const selectedQty = () => {
        const minimum = Number(quantityInput?.min) || 1;
        const value = Number(quantityInput?.value) || minimum;
        return Math.max(minimum, value);
      };
      const sync = () => {

        const variantId = variantSelect?.value;
        if (!variantId || addButton?.disabled) {
          buyLink.removeAttribute('href');
          buyLink.setAttribute('aria-disabled', 'true');
          buyLink.classList.add('is-disabled');
          return;
        }
        buyLink.href = `/cart/${variantId}:${selectedQty()}`;
        buyLink.setAttribute('aria-disabled', 'false');
        buyLink.classList.remove('is-disabled');
      };

      form.addEventListener('change', () => setTimeout(sync, 0));
      form.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => setTimeout(sync, 0)));
      buyLink.addEventListener('click', (event) => { sync(); if (buyLink.getAttribute('aria-disabled') === 'true' || !buyLink.getAttribute('href')) event.preventDefault(); });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();